module.exports = __webpack_public_path__ + "img/LATIN10_09.741da2c3.jpg";